import React, { useState } from "react";
import { Modal, notification, Button, Select } from "antd";
import { addCandidateToRole } from "api/project.api";
import SelectTalentPool from "components/Select/SelectTalentPool";
import { useDispatch } from "react-redux";
import { toggleProjectDetailRefresh } from "store/slices/talentPool";


const getActionLabel = (action: "select" | "reject" | "import" | "suggest"): string => {
    const labels: Record<typeof action, string> = {
        select: "shortlisted",
        reject: "rejected",
        import: "imported",
        suggest: "suggested",
    };
    return labels[action];
};

interface CandidateModalProps {
    isVisible: boolean;
    onClose: () => void;
    selectedCandidates: number[];
    selectedPool?: number | null;
    isAddToProject: boolean;
    allIdsSelected?: boolean;
    isSearch?: boolean;
    type?: "select" | "reject" | "import" | "suggest";
    searchId?: number;
}

const CandidateModal: React.FC<CandidateModalProps> = ({
    isVisible,
    onClose,
    selectedCandidates,
    selectedPool,
    isAddToProject,
    allIdsSelected,
    type = "suggest",
    isSearch,
    searchId
}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const dispatch = useDispatch();
    const [selectedTalentedPool, setSelectedTalentedPool] = useState<number | null>(null);
    const handleAddCandidate = async () => {
        const payload = {
            jobs: [selectedTalentedPool],
            candidates: selectedCandidates,
            is_shortlisted: true,
        };

        const allIdsPayload = {
            jobs: [selectedTalentedPool],
            candidates: [],
            is_shortlisted: true,
            ...(isSearch ? { search_id: searchId } : { job_id: selectedPool }),
            candidates_to_get: getActionLabel(type)
        };

        const actualPayload = allIdsSelected ? allIdsPayload : payload;
        setLoading(true);
        try {
            await addCandidateToRole(actualPayload);
            notification.success({
                message: 'Success',
                description: isAddToProject
                    ? 'Candidate successfully added to the project.'
                    : 'Candidate successfully moved to the talent pool.',
            });
            onClose();
            dispatch(toggleProjectDetailRefresh());
        } catch (error) {
            notification.error({
                message: 'Error',
                description: isAddToProject
                    ? 'Failed to add candidate to the project.'
                    : 'Failed to move candidate to the talent pool.',
            });
        } finally {
            setLoading(false);
        }
    };



    const handleSelectChange = (value: number) => {
        setSelectedTalentedPool(value);
    };

    return (
        <Modal
            title={isAddToProject ? "Add to Project" : "Move to Talent Pool"}
            visible={isVisible}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,

                <Button key="submit" type="primary" loading={loading} onClick={handleAddCandidate}>
                    Submit
                </Button>,
            ]}
        >
            <SelectTalentPool
                handleSelectChange={handleSelectChange}
                selectedPool={selectedTalentedPool}
                isAddToProject={isAddToProject}
            />
        </Modal>
    );
};

export default CandidateModal;
